// extracted by css-extract-rspack-plugin
export default {"confluenceIcon":"CQAjEGhqH1kMU7SP","confluenceButton":"lMxcfzXZs3cP6r79","confluenceModalBody":"_XzefFguS4EnaRov"};